import API from '../../../../commons/api/api';
import * as actionTypes from '../actions/type';
import {isProcessing} from "../actions";
import {formatAppSnsType, removeAllStorage} from "../../../../utils/helpers";

export const initialState = {
  token: '',
  userInfo: {} ,
  isProcessing: false,
  statusCode: null,
  isProcessingUpdate: false
};


const authReducers = (state  = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_REQUEST:
      console.log('authReducers', action.type);
      return { 
        ...state, 
        isProcessing: true, 
        type: action.type 
      };
    case actionTypes.LOGIN_SUCCESS:
      let res = action.payload;
      localStorage.setItem('_APP_TOKEN', `${res.data.token}`);
      API.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
      window.nativeLoginToken(res.data.token);
      if(res && res.data && res.data.v1_data){
        let v1Data = JSON.stringify(res.data.v1_data);
        window.sendUserInfo(v1Data);
      }
      return {
        ...state,
        isProcessing: false,
        token: res.data.token,
        statusCode: res.status,
        statusText: res.msg,
        userInfo: res.data.data,
        type: action.type,
      };
    case actionTypes.LOGIN_FAILD:
      console.log('actionTypes.LOGIN_FAILD', action);
      return {
        ...state,
        isProcessing: false,
        token:'',
        statusCode: 400,
        statusText: '',
        userInfo: {},
        type: action.type,
        errors : action.payload ?? {}
      }

    case actionTypes.LOGOUT_REQUEST:
      console.log('authReducers', action.type);
      return { 
        ...state, 
        isProcessing: true, 
        type: action.type 
      };
    case actionTypes.LOGOUT_SUCCESS:
      let snsType = formatAppSnsType(localStorage.getItem('sns_type') || '');
      window.nativeLogoutToken(snsType);
      removeAllStorage();
      return {
        ...state,
        isProcessing: false,
        token:'',
        statusCode: 400,
        statusText: '',
        userInfo: {},
        type: action.type,
      };
    case actionTypes.LOGOUT_FAILD:
      return {
        ...state,
        isProcessing: false,
        token:'',
        statusCode: 400,
        statusText: '',
        userInfo: {},
        type: action.type,
      };
    case actionTypes.UPDATE_SUCCESS :
      return {
        ...state,
        userInfo :  action.payload
      }
    case actionTypes.UPDATE_CHILDREN_PROFILE_SUCCESS :
      return {
        ...state,
        userInfo : {
          ...state.userInfo,
          childrens : action.payload.childrens,
          favorite_characters :  action.payload.favorite_characters,
        }
      }
    case actionTypes.UPDATE_NOTIFICATION_SETTING_SUCCESS :
      return {
        ...state,
        userInfo : {
          ...state.userInfo,
          setting : action.payload
        }
      }

    case actionTypes.LOGIN_SNS_REQUEST:
      return {
        ...state,
        isProcessing: true,
        type: action.type
      };
    case actionTypes.LOGIN_SNS_SUCCESS:
      let response = action.payload;
      localStorage.setItem('_APP_TOKEN', `${response.data.token}`);
      API.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
      window.nativeLoginToken(response.data.token)

      if(response && response.data && response.data.v1_data){
        let v1Data = JSON.stringify(response.data.v1_data);
        window.sendUserInfo(v1Data);
      }

      return {
        ...state,
        isProcessing: false,
        token: response.data.token,
        statusCode: response.status,
        statusText: response.msg,
        userInfo: response.data.data,
        type: action.type,
      };
    case actionTypes.LOGIN_SNS_FAILD:
      return {
        ...state,
        isProcessing: false,
        token:'',
        statusCode: 400,
        statusText: '',
        userInfo: {},
        type: action.type,
        errors : action.payload ?? {}
      }
    case actionTypes.GET_CURRENT_USER:
      let token = localStorage.getItem('_APP_TOKEN') || '';
      window.nativeLoginToken(token);
      if(action.payload && action.payload.v1_data){
        let v1Data = JSON.stringify(action.payload.v1_data);
        window.sendUserInfo(v1Data);
      }
      return {
        ...state,
        isProcessing: false,
        token: token,
        statusCode: 200,
        type: action.type,
        userInfo :  {
          ...state.userInfo,
          ...action.payload.data
        }
      }
    case actionTypes.RESET_STATE:
      return {
        isProcessing: false,
        token:'',
        statusCode: null,
        statusText: '',
        userInfo: {},
        type: action.type
      }
    case actionTypes.IS_PROCESSING :
      return {
        ...state,
        isProcessing: true,
      }
    case actionTypes.UPDATE_USER_REQUEST: 
    return {
      ...state,
      isProcessingUpdate: true
    }
    case actionTypes.UPDATE_USER_SUCSESS: 
    return {
      ...state,
      userInfo :  action.payload
    }
    default:
      return state;
  }
};

export default authReducers;
